// footer.jsx
import React, { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import '../allcss/footer.css';
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt
} from 'react-icons/fa';
import { FaFacebookF, FaInstagram, FaXTwitter, FaGoogle, FaChevronRight } from 'react-icons/fa6';
import logo from '../Asets/redlogo1.png';

const Footer = () => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    if (location.pathname !== '/') return;

    const sectionIds = ['home', 'about', 'programs', 'contact'];
    const sections = sectionIds
      .map((id) => document.getElementById(id))
      .filter(Boolean);

    if (sections.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, [location.pathname]);

  const isHashActive = (id) =>
    location.pathname === '/' && activeSection === id;

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-brand">
          <div className="logo-container">
            <img src={logo} alt="RedSchoolHouse Splash" />
          </div>
          <p>
            <strong>RED School House</strong> provides a safe, nurturing, and
            engaging learning environment where children develop confidence,
            creativity, and essential life skills through play-based learning
            and a Singapore-inspired curriculum. Our programs support every
            stage of early childhood development, helping children build a
            strong foundation for lifelong learning.
          </p>
        </div>

        <div className="footer-columns">
          {/* Quick Links */}
          <div className="footer-column">
            <h4>Quick Link</h4>
            <ul>
              <li><FaChevronRight className="link-icon" /><Link to="/#home" className={isHashActive("home") ? "active" : ""}>Home</Link></li>
              <li><FaChevronRight className="link-icon" /><Link to="/#about" className={isHashActive("about") ? "active" : ""}>About Us</Link></li>
              <li><FaChevronRight className="link-icon" /><Link to="/#programs" className={isHashActive("programs") ? "active" : ""}>Program</Link></li>
              <li><FaChevronRight className="link-icon" /><Link to="/#contact" className={isHashActive("contact") ? "active" : ""}>Admission</Link></li>
              <li><FaChevronRight className="link-icon" /><NavLink to="/blog" className={({ isActive }) => isActive ? "active" : ""}>Blog</NavLink></li>
              <li><FaChevronRight className="link-icon" /><NavLink to="/Artculture" className={({ isActive }) => isActive ? "active" : ""}>Art Culture</NavLink></li>
              <li><FaChevronRight className="link-icon" /><NavLink to="/contact" className={({ isActive }) => isActive ? "active" : ""}>Contact Us</NavLink></li>
            </ul>
          </div>

          {/* Quick Information */}
          <div className="footer-column">
            <h4>Quick Information</h4>
            <ul>
              <li>
                <FaPhoneAlt />
                <a
                  href="tel:+917778851070"
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  +91 7778851070
                </a>
              </li>
              <li>
                <FaEnvelope />
                <a
                  href="mailto:redschoolhousebaroda@gmail.com"
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  redschoolhousebaroda@gmail.com
                </a>
              </li>
              <li className="address-item">
                <FaMapMarkerAlt />
                <span>
                  A-25, Castle White, Opp. Harni Water Tank, Harni-Sama Link
                  Road, Vadodara.
                </span>
              </li>
            </ul>

            {/* Follow Us - now stacked below Quick Information */}
            <div className="social-column">
              <h4>Follow us on</h4>
              <div className="social-icons">
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://www.instagram.com/redschoolhousebaroda/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://x.com/RedSchoolHouse1"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="X (Twitter)"
                >
                  <FaXTwitter />
                </a>
                <a
                  href="https://share.google/wK4OG1iDD2OWbY0XK"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Google Business Profile"
                >
                  <FaGoogle />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 RedSchoolHouse. All rights reserved.</p>
        <p>
          Made with ❤️ by Mark Digital
        </p>
      </div>
    </footer>
  );
};

export default Footer;